import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ActivityLog\FetchLogActivitiesController::__invoke
* @see app/Http/Controllers/ActivityLog/FetchLogActivitiesController.php
* @route '/api/activities'
*/
const FetchLogActivitiesController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchLogActivitiesController.url(options),
    method: 'get',
})

FetchLogActivitiesController.definition = {
    methods: ["get","head"],
    url: '/api/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ActivityLog\FetchLogActivitiesController::__invoke
* @see app/Http/Controllers/ActivityLog/FetchLogActivitiesController.php
* @route '/api/activities'
*/
FetchLogActivitiesController.url = (options?: RouteQueryOptions) => {
    return FetchLogActivitiesController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ActivityLog\FetchLogActivitiesController::__invoke
* @see app/Http/Controllers/ActivityLog/FetchLogActivitiesController.php
* @route '/api/activities'
*/
FetchLogActivitiesController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchLogActivitiesController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ActivityLog\FetchLogActivitiesController::__invoke
* @see app/Http/Controllers/ActivityLog/FetchLogActivitiesController.php
* @route '/api/activities'
*/
FetchLogActivitiesController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchLogActivitiesController.url(options),
    method: 'head',
})

export default FetchLogActivitiesController